import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {DataTable} from '../shared';
import axios from 'axios';
import {passCsrfToken, toTableData} from '../../helpers';
import EditUserForm from '../users/EditUserForm';
import {getUsers, deleteUser, convertUserToVendor, convertUserToGeneral} from '../../api/userApi';
import swal from 'sweetalert';
import history from '../../history';
import {CustomMenu} from './Menu';
import {Badge} from '../shared';
import queryString from 'query-string';
import {Card, Pagination} from 'semantic-ui-react';
import moment from 'moment';

class UsersList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			users: [],
			editing: false,
			selectedUser: null,
			pagination: {},
			convertingId: null,
			convertingToGeneralId: null,
			openActionsFor: null // user.idx for which row's actions dropdown is open (mobile)
		};
		this.dropdownRef = React.createRef();
	}

	changeCurrentPage = (e, {activePage}) => {
		var searchQuery = `?page=${activePage}`;
		this.setState({currentPage: activePage});
		this.fetchUsers({page: activePage});
		history.push({
			pathname: window.location.pathname,
			search: searchQuery
		});
	};

	componentDidMount() {
		passCsrfToken(document, axios);
		this.fetchUsers(queryString.parse(this.props.location.search));
		this._boundCloseActionsOutside = this._closeActionsOutside.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.openActionsFor !== prevState.openActionsFor) {
			if (this.state.openActionsFor != null) {
				document.addEventListener('click', this._boundCloseActionsOutside, true);
			} else {
				document.removeEventListener('click', this._boundCloseActionsOutside, true);
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener('click', this._boundCloseActionsOutside, true);
	}

	_closeActionsOutside(e) {
		if (this.state.openActionsFor == null) return;
		const el = this.dropdownRef && this.dropdownRef.current;
		if (el && !el.contains(e.target)) this.setState({ openActionsFor: null });
	}

	fetchUsers = (params) => {
		getUsers(params)
			.then((response) => {
				const data = response.data || {};
				const list = Array.isArray(data) ? data : (data.users || []);
				const meta = data.meta || {};
				const pagination = meta.pagination || {};
				this.setState({
					users: list,
					pagination
				});
			})
			.catch((error) => {
				console.warn('User list fetch error', error);
			});
	};

	destroyUser(id) {
		// deleteUser(id)
		// 	.then((response) => {
		// 		swal({
		// 			title: 'User deleted!',
		// 			text: `this user is deleted`,
		// 			icon: 'success',
		// 			button: 'Continue!'
		// 		});
		// 		history.go();
		// 	})
		// 	.catch((error) => {
		// 		swal({
		// 			title: 'User Delete error',
		// 			text: 'Something went wrong. please try again or contact us',
		// 			icon: 'error',
		// 			button: 'Continue!'
		// 		});
		// 	});

		swal({
			title: 'Are you sure?',
			text: 'Once delete, your user will be deleted',
			icon: 'warning',
			buttons: true,
			dangerMode: true
		}).then((willDelete) => {
			if (willDelete) {
				deleteUser(id).then((response) => {
					swal('Your user has been deleted', {
						icon: 'success'
					});
					history.go();
				});
			} else {
				swal('Your user is not deleted yet');
			}
		});
	}

	onFilter = (values) => {
		this.setState({
			users: values.users
		});
	};

	convertToVendor = (user) => {
		const idOrIdx = user.id != null ? user.id : user.idx;
		if (!idOrIdx) return;
		swal({
			title: 'Convert to Vendor?',
			text: `Make "${user.name}" (${user.email}) a vendor? They will get a vendor record and can log in to the partner dashboard.`,
			icon: 'info',
			buttons: { cancel: 'Cancel', confirm: 'Convert' }
		}).then((confirmed) => {
			if (!confirmed) return;
			this.setState({ convertingId: idOrIdx });
			convertUserToVendor(idOrIdx)
				.then((res) => {
					swal('Done', res.data?.message || 'User converted to vendor.', 'success');
					this.fetchUsers(queryString.parse(this.props.location.search));
				})
				.catch((err) => {
					const msg = (err.response?.data?.errors || [])?.join(' ') || err.message || 'Conversion failed.';
					swal('Error', msg, 'error');
				})
				.finally(() => this.setState({ convertingId: null }));
		});
	};

	convertToGeneral = (user) => {
		const idOrIdx = user.id != null ? user.id : user.idx;
		if (!idOrIdx) return;
		swal({
			title: 'Convert to General?',
			text: `Set "${user.name}" (${user.email}) to General role? They will no longer have vendor/partner access.`,
			icon: 'info',
			buttons: { cancel: 'Cancel', confirm: 'Convert' }
		}).then((confirmed) => {
			if (!confirmed) return;
			this.setState({ convertingToGeneralId: idOrIdx });
			convertUserToGeneral(idOrIdx)
				.then((res) => {
					swal('Done', res.data?.message || 'User converted to General.', 'success');
					this.fetchUsers(queryString.parse(this.props.location.search));
				})
				.catch((err) => {
					const msg = (err.response?.data?.errors || [])?.join(' ') || err.message || 'Conversion failed.';
					swal('Error', msg, 'error');
				})
				.finally(() => this.setState({ convertingToGeneralId: null }));
		});
	};

	render() {
		const {users, pagination} = this.state;
		const filterFields = [
			{
				name: 'created_at_gteq',
				label: 'From Date',
				type: 'date'
			},
			{
				name: 'created_at_lteq',
				label: 'To Date',
				type: 'date'
			},
			{
				name: 'name_cont',
				label: 'name',
				type: 'text'
			},

			{
				name: 'email_cont',
				label: 'email',
				type: 'text'
			},

			{
				name: 'phone_number_cont',
				label: 'Mobile Number',
				type: 'text'
			}
		];
		return (
			<div className='ui container'>
				<CustomMenu
					submitUrl='admin/users'
					filterFields={filterFields}
					onFilter={(values) => this.onFilter(values)}
					items={[
						{
							label: 'Role',
							type: 'dropdown',
							name: 'role_name_eq',
							objects: [
								{ label: 'Admin', value: 'Admin' },
								{ label: 'Support', value: 'Support' },
								{ label: 'General', value: 'General' },
								{ label: 'Vendor', value: 'Vendor' }
							]
						}
					]}
				/>

				<Card fluid>
					<Card.Content>
						<h3 className='title'>Users</h3>
						<div className='table-responsive'>
							<table className='table table-striped table-hover table-sm' ref='main'>
								<thead>
									<tr>
										<th className='d-none d-md-table-cell'>S. No.</th>
										<th>Name</th>
										<th>Email</th>
										<th>Role</th>
										<th className='d-none d-md-table-cell'>Mobile Number</th>
										<th className='d-none d-md-table-cell'>Created At</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{users.map((user, index) => {
										const userKey = user.idx != null ? user.idx : (user.id != null ? user.id : index);
										const isDropdownOpen = this.state.openActionsFor === userKey;
										return (
											<tr key={userKey} className='align-middle'>
												<td className='d-none d-md-table-cell py-3'>{index + 1}</td>
												<td className='py-3'>{user.name}</td>
												<td className='py-3'>{user.email}</td>
												<td className='py-3'>
													<Badge type={user.role}>{user.role}</Badge>
												</td>
												<td className='d-none d-md-table-cell py-3'>{user.phone_number}</td>
												<td className='d-none d-md-table-cell py-3'>{moment(user.created_at).format('D MMMM, YYYY')}</td>
												<td className='py-3'>
													{/* Desktop: inline buttons */}
													<div className='d-none d-md-block'>
														<Link
															to={{ pathname: `/users/edit/${user.idx}`, state: { user } }}
															className='btn bg-none text-primary'
														>
															Edit
														</Link>
														<Link
															to={{ pathname: '/admin/email', state: { user } }}
															className='btn bg-none text-primary'
														>
															Contact
														</Link>
														{user.role !== 'Vendor' && (
															<button
																type='button'
																className='btn bg-none text-info'
																onClick={() => this.convertToVendor(user)}
																disabled={this.state.convertingId != null}
															>
																{this.state.convertingId === (user.id != null ? user.id : user.idx) ? 'Converting…' : 'Convert to Vendor'}
															</button>
														)}
														{user.role === 'Vendor' && (
															<button
																type='button'
																className='btn bg-none text-secondary'
																onClick={() => this.convertToGeneral(user)}
																disabled={this.state.convertingToGeneralId != null}
															>
																{this.state.convertingToGeneralId === (user.id != null ? user.id : user.idx) ? 'Converting…' : 'Convert to General'}
															</button>
														)}
														<span
															className='btn bg-none text-danger'
															onClick={() => this.destroyUser(user.idx)}
														>
															Delete
														</span>
													</div>
													{/* Mobile: single Actions dropdown */}
													<div className='dropdown d-md-none' ref={isDropdownOpen ? this.dropdownRef : undefined}>
														<button
															type='button'
															className='btn btn-outline-secondary btn-sm dropdown-toggle'
															aria-haspopup='true'
															aria-expanded={isDropdownOpen}
															onClick={() => this.setState((s) => ({ openActionsFor: s.openActionsFor === userKey ? null : userKey }))}
														>
															⋮ Actions
														</button>
														<div className={`dropdown-menu dropdown-menu-right ${isDropdownOpen ? 'show' : ''}`} style={isDropdownOpen ? { display: 'block' } : undefined}>
															<Link
																to={{ pathname: `/users/edit/${user.idx}`, state: { user } }}
																className='dropdown-item w-100 text-left'
																onClick={() => this.setState({ openActionsFor: null })}
															>
																Edit
															</Link>
															<Link
																to={{ pathname: '/admin/email', state: { user } }}
																className='dropdown-item w-100 text-left'
																onClick={() => this.setState({ openActionsFor: null })}
															>
																Contact
															</Link>
															{user.role !== 'Vendor' && (
																<button
																	type='button'
																	className='dropdown-item w-100 text-left text-info'
																	onClick={() => { this.setState({ openActionsFor: null }); this.convertToVendor(user); }}
																	disabled={this.state.convertingId != null}
																>
																	{this.state.convertingId === (user.id != null ? user.id : user.idx) ? 'Converting…' : 'Convert to Vendor'}
																</button>
															)}
															{user.role === 'Vendor' && (
																<button
																	type='button'
																	className='dropdown-item w-100 text-left text-secondary'
																	onClick={() => { this.setState({ openActionsFor: null }); this.convertToGeneral(user); }}
																	disabled={this.state.convertingToGeneralId != null}
																>
																	{this.state.convertingToGeneralId === (user.id != null ? user.id : user.idx) ? 'Converting…' : 'Convert to General'}
																</button>
															)}
															<button
																type='button'
																className='dropdown-item w-100 text-left text-danger'
																onClick={() => { this.setState({ openActionsFor: null }); this.destroyUser(user.idx); }}
															>
																Delete
															</button>
														</div>
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</Card.Content>
				</Card>
				{/* <DataTable data={toTableData(users)} /> */}

				<div className='text-center p-2'>
					<Pagination
						activePage={pagination.current_page}
						sizePerPage={pagination.per_page}
						onPageChange={this.changeCurrentPage}
						totalPages={pagination.total_pages}
					/>
				</div>
			</div>
		);
	}
}
export default UsersList;
